<template>
  <paper>
    <div class="tender-maintenance">
      <div class="maintenance-input">
        <el-row class="search-box" :gutter="10">
          <el-col :span="3">
            <div class="search">
              <el-input placeholder="招标编码" v-model="form.bidNo" clearable></el-input>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search">
              <el-input placeholder="招标名称" v-model="form.bidName" clearable></el-input>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search">
              <MSelect
                :optionNum="'SU_BID_TYPE'"
                :value="form.bidType"
                :filterable="true"
                :placeholder="'招标方式'"
                @input="getBidType"
                clearable
              ></MSelect>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search">
              <MSelect
                ref="bidStatus"
                :value="form.bidStatus"
                :filterable="true"
                :placeholder="'招标状态'"
                @input="getBidStatus"
                clearable
              ></MSelect>
            </div>
          </el-col>
          <el-col :span="4.5">
            <div class="search">
              <el-date-picker
                v-model="form.signUpEndTimeStart"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="报名截止时间从"
                clearable
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="4.5">
            <div class="search">
              <el-date-picker
                v-model="form.signUpEndTimeEnd"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="报名截止时间到"
                clearable
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search">
                <otp-advance
                    :mValue="form.companyName"
                    :params="companyParams"
                    @getAdvanceValue="getCompanyName"
                ></otp-advance>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search" style="">
              <MSelect class="el-input professional-company" :optionNum="'SYS_PROFESSIONAL_COMPANY'" collapse-tags :multiple-limit="5" :value="form.professionalCompanyList" :multiple="true" :placeholder="'专业公司'" :filterable="true" @input="getProfessionalCompany"></MSelect>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search" style="">
              <mSelect class="el-input professional-company" :optionNum="'SRM_CONTRACT_IS_GROUP_CUSTOMER'" placeholder="客户类型" :value="form.customerTypeList" collapse-tags :multiple="true" :filterable="true"  @input="getCustomerType"></mSelect>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search" style="">
              <mSelect class="el-input professional-company" :optionNum="'BID_BUSINESS_TYPE'" placeholder="业务类型" :value="form.businessTypeList" collapse-tags :multiple="true" :filterable="true"  @input="getBusinessType"></mSelect>
            </div>
          </el-col>
          <el-col :span="4.5">
            <div class="search">
              <el-date-picker
                class="tender-list-date-picker"
                v-model="form.purchaseTimeRange"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="购买标书时间"
                end-placeholder="购买标书时间"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4.5">
            <div class="search">
              <el-date-picker
                class="tender-list-date-picker"
                v-model="form.awardOfBidTimeRange"
                type="datetimerange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="决标开始时间"
                end-placeholder="决标结束时间"
                :picker-options="pickerOptions"
                format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search">
              <MSelect :optionNum="'SRM_YES_NO'" :value="form.isRecall" :placeholder="'是否召回公告'" @input="getIsRecall"></MSelect>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="search">
              <el-input placeholder="组织者" clearable :value="form.organizerName" @clear="handleOrgClear">
                  <el-button slot="append" icon="el-icon-search" @click="handleOpenGroup"></el-button>
              </el-input>
            </div>
          </el-col>
          <el-col class="select-btn-box" :span="1">
            <span>
              <span v-has="'02010059'">
                <el-button type="primary" class="search bigData-btn-search" @click="tenderSeach" :loading="loadBtn">查 询</el-button>
              </span>
            </span>
            <el-tooltip class="m-l-10 header-button-btn" effect="dark" content="导出" placement="bottom">
                <el-button icon="el-icon-download" size="mini" @click="exportFunc"></el-button>
            </el-tooltip>
          </el-col>
        </el-row>
      </div>
      <el-table border :data="tableData" height="90" @cell-dblclick="openactivename" style="width:99.8%;">
        <el-table-column prop="bidNo" label="招标编码" width="210" ></el-table-column>
        <el-table-column prop="bidName" label="招标名称" width="355" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="unionBidCompanyName" label="联合招标分公司" width="355" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="bidTypeText" label="招标方式" width="160"></el-table-column>
        <el-table-column prop="bidStatusText" label="招标状态" width="175"></el-table-column>
        <el-table-column prop="isRecallText" label="是否召回招标" width="100">
          <template slot-scope="scope" >
            <div :class="{ 'recall-text-yes': scope.row.isRecallText === '是' }">
                {{scope.row.isRecallText}}
            </div>
        </template>
        </el-table-column>
        <el-table-column prop="purchaseStartTime" label="标书购买开始时间" width="150"></el-table-column>
        <el-table-column prop="signUpEndTime" label="报名截止时间" width="150"></el-table-column>
        <el-table-column prop="awardOfBidTime" label="决标时间" width="150"></el-table-column>
        <el-table-column label="审批流" align="center" fixed="right" min-width="300">
          <template slot-scope="scope">
            <span v-has="'02010060'"><el-button size="mini" class="tab-tbn" v-if="scope.row.mip[2]"  type="text" @click="bidProgramme(scope.row)">招标方案</el-button></span>
            <span v-has="'02010061'"><el-button size="mini" class="tab-tbn" v-if="scope.row.mip[4]" type="text" @click="bidPrice(scope.row)">拦标价</el-button></span>
            <span v-has="'02010062'"><el-button size="mini" class="tab-tbn" v-if="scope.row.mip[3]" type="text" @click="bidResult(scope.row)">招标结果</el-button></span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        class="text-right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNo"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <GroupDialog :checkPerStatus="openPerDialog" @perDialog="overPerDialog" @closePerDialog="closePerDialog" v-if="openPerDialog.showDialog"></GroupDialog>
  </paper>
</template>
<script>
import dayjs from 'dayjs';
import MSelect from '@/components/lots/otpSelect2';
import paper from '@/components/core/paper/Paper';
import OtpAdvance from '@/components/lots/otpAdvance';
import GroupDialog from '../../../components/personOne/groupDialog.vue';
import { tenderEnquiry } from '../../../api/tenderEnquiry.js';
import { dictWithUrl } from '@/components/lots/api.js';
import { mapGetters } from 'vuex';
import config from '@/config/user.env';
import { SRM_FILE_PRE } from '../../../constant/constant.js';

const pickerOptions = {
    shortcuts: [
        {
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近三个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
            }
        }
    ]
};

const companyParams = {
    name: '分公司',
    value: 'companyName',
    advanceLabel: '分公司弹出框',
    advanceConfig: [
        { prop: 'ALL', value: '全部' },
        { prop: 'companyCode', value: '分公司编码' },
        { prop: 'companyNameCn', value: '分公司名称' }
    ],
    tableConfig: [
        { prop: 'companyCode', value: '分公司编码' },
        { prop: 'companyNameCn', value: '分公司名称' }
    ],
    advanceUrl: '/esCompany/popCompany',
    cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
    multipleTableColumn: { prop: 'companyNameCn', value: '分公司名称' }
};

export default {
    name: 'tendermanagement',
    components: { MSelect, paper, OtpAdvance, GroupDialog },
    data() {
        return {
            loadBtn: false,
            dictData: {}, // 数字字典
            searchParams: {}, // 查询条件
            form: {
                bidNo: '',
                bidName: '',
                bidType: '',
                bidStatus: '',
                signUpEndTimeStart: '',
                signUpEndTimeEnd: '',
                purchaseTimeRange: '',
                companyCode: '',
                companyName: '',
                purchaseStartTimeStart: '',
                professionalCompanyList: [],
                customerTypeList: [],
                businessTypeList: [],
                isRecall: '',
                purchaseStartTimeEnd: '',
                awardOfBidTimeRange: '',
                awardOfBidStartTime: '',
                awardOfBidEndTime: '',
                organizerCode: '',
                organizerName: '',
                userCode: this.$store.getters.user.userCode,
            },
            page: {
                pageNo: 1,
                pageSize: 10
            },
            totalCount: 0,
            tableData: [],
            pickerOptions,
            iflowId: this.$route.query.mbpmFlowId,
            companyParams,

            openPerDialog: {
                openIndex: '',
                showDialog: false,
                checkedList: []
            },
        };
    },
    activated(){
      this.initQuery()
   
    },
    mounted() {
      this.initQuery('mounted')
      this.getDicData()
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode'])
    },
    methods: {
      initQuery(param){
        let fromPage= this.$route.query.fromPage;
        if (fromPage==='biddingProcurementWholeProcess') {
            this.form.bidNo = this.$route.query.bidNo
            this.form.purchaseTimeRange = '';
            this.form.awardOfBidTimeRange = '';
        };
        if(!param){
          this.getDicData()
        }
      },
      getProfessionalCompany(value) {
            this.form.professionalCompanyList = value;
      },
      getDicData(){
        // 数字字典转换
        dictWithUrl('SU_BID_TYPE,BID_STATUS,SRM_YES_NO').then(res => {
                this.dictData = res.data;
                this.searchParams = { ...this.form }
                this.loadData();

                let bidStatusObj = this.dictData.BID_STATUS;
                let bidStatusList=[];
                for (const key in bidStatusObj) {
                  let row={
                    label: bidStatusObj[key],
                    value: key,
                  }
                  bidStatusList.push(row);
                  bidStatusList.sort((a,b)=>{
                    return a.value-b.value
                  })
                }
                this.$refs.bidStatus.options=bidStatusList;
        });
      },
    // 双击单元格
        openactivename(row, column, event, cell) {
            this.$router.push({ name: 'tenderdocument', query: { bidNo: row.bidNo } });
        },
        getBidType(val) {
            this.form.bidType = val;
        },
        getCustomerType(value) {
            this.form.customerTypeList = value;
        },
        getBusinessType(value) {
            this.form.businessTypeList = value;
        },
        getIsRecall(value) {
            this.form.isRecall = value;
        },
        getBidStatus(val) {
            this.form.bidStatus = val;
        },
        handleSizeChange(val) {
            this.page.pageNo = 1;
            this.page.pageSize = val;
            this.loadData();
        },
        handleCurrentChange(val) {
            this.page.pageNo = val;
            this.loadData();
        },
        exportFunc(submit) {
            const obj = this.getParams();
            delete obj.pageNo;
            delete obj.pageSize;
            let str = '?';
            Object.keys(obj).forEach((el, i) => {
                str += el + '=' + obj[el];
                if (i < Object.keys(obj).length - 1) {
                    str += '&';
                }
            });
            const exportUrl = `${config.pdfPreviewUrl}${SRM_FILE_PRE}/bid/bidHead/exportBidHeadAudits${str}`;
            window.location = exportUrl;
        },
        // 招标结果mip
        async bidResult(row) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: row.mip[3],
                    path: 'tendermanagement',
                    formInstanceId: row.bidNo,
                    accuratePosition:'tenderResult'
                }
            });
        },
        // 拦标价mip
        async bidPrice(row) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: row.mip[4],
                    path: 'tendermanagement',
                    formInstanceId: row.bidNo
                }
            });
        },
        // 招标方案mip
        async bidProgramme(row) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: row.mip[2],
                    path: 'tendermanagement',
                    formInstanceId: row.bidNo
                }
            });
        },
        init() {
            this.loadData();
        },
        async loadData() {
            const params = this.getParams();
            const res = await tenderEnquiry({...params,iflowId: this.iflowId}).catch(err => {});
            this.loadBtn = false;
            if (res && res.code === '0') {
                this.tableData = res.data.list;
                this.conversionData(this.tableData);
                this.tableData.forEach(item => {
                    item.mip = { 2: '', 3: '', 4: '' };
                    if (item.auditTypes && item.fdIds) {
                        const typeArr = item.auditTypes.split(',');
                        const idArr = item.fdIds.split(',');
                        typeArr.forEach((it, index) => {
                            for (const key in item.mip) {
                                if (key === it) {
                                    item.mip[key] = idArr[index];
                                }
                            }
                        });
                    }
                });
                this.totalCount = res.data.totalCount;
            }
        },
        conversionData(list) {
            list.map(item => {
                item.bidTypeText = this.dictData.SU_BID_TYPE[item.bidType];
                item.bidStatusText = this.dictData.BID_STATUS[item.bidStatus];
                item.isRecallText = this.dictData.SRM_YES_NO[item.isRecall];
            });
            return list;
        },
        tenderSeach() {
            this.loadBtn = true;
            this.searchParams = { ...this.form }
            this.page.pageNo = 1;
            this.loadData();
        },
        getParams() {
            const params = { ...this.searchParams, ...this.page };
            params.purchaseStartTimeStart = params.purchaseTimeRange ? dayjs(params.purchaseTimeRange[0]).format('YYYY-MM-DD HH:mm:ss') : '';
            params.purchaseStartTimeEnd = params.purchaseTimeRange ? dayjs(params.purchaseTimeRange[1]).format('YYYY-MM-DD HH:mm:ss') : '';
            delete params.purchaseTimeRange;
            params.awardOfBidStartTime = params.awardOfBidTimeRange ? dayjs(params.awardOfBidTimeRange[0]).format('YYYY-MM-DD HH:mm:ss') : '';
            params.awardOfBidEndTime = params.awardOfBidTimeRange ? dayjs(params.awardOfBidTimeRange[1]).format('YYYY-MM-DD HH:mm:ss') : '';
            delete params.awardOfBidTimeRange;
            delete params.organizerName
            return params;
        },
        getCompanyName(val) {
            this.form.companyName = val.companyName;
            this.form.companyCode = val.companyCode;
        },
        handleOrgClear() {
            this.form.organizerCode = ''
            this.form.organizerName = ''
        },
        // 人员选择器打开
        handleOpenGroup() {
            let checkedList = []
            if (this.form.organizerCode) {
                checkedList = [{ userCode: this.form.organizerCode, userName: this.form.organizerName }]
            }
            this.openPerDialog = { openIndex: '0', showDialog: true, checkedList }
        },
        // 人员选择器选中
        overPerDialog(data) {
            this.openPerDialog.showDialog = data.open
            if (data.checklist.length) {
                this.form.organizerCode = data.checklist[0].userCode
                this.form.organizerName = data.checklist[0].userName
            }
        },
        // 人员选择器关闭
        closePerDialog(data) {
            this.openPerDialog.showDialog = data.open
        },
    }
};
</script>
<style lang='less'>
.tender-maintenance {
    .search {
        margin-bottom: 10px;
    }

    .professional-company {
        margin-right: 35px;
        margin-bottom: 0;

        .el-input {
            display: inline-block;
            height: 27.99px;
        }

        .el-select__tags{
            height: 27.99px;

            span {
                display:flex;
                align-items:center;
            }
        }

        .el-select{
            height: 27.99px;
        }

        .el-input__inner{
            position: relative;
            height: 27.99px !important;
        }
    }

    .content_list {
        margin-top: 10px;
    }

    .event + .event {
        margin-left: 10px;
    }

    .el-table {
        min-height: calc(~"100vh - 200px");
        max-height: calc(~"100vh - 200px");
    }

    .el-table--border {
        border: 1px solid #ebeef5;
    }
    .tab-tbn{ margin-left:10px; }

    .select-btn-box {
        display: flex;
        align-items: baseline;
    }

    .m-l-10 {
        margin-left: 10px;
    }

    .recall-text-yes {
        color: #f96c5f;
    }
}
</style>